import { HttpTypes } from "@medusajs/types";

export const isSimpleProduct = (product: HttpTypes.StoreProduct): boolean => {
  const optionCount = product.options?.length ?? 0

  return (
    product.variants?.length === 1 &&
    (optionCount === 0 ||
      (optionCount === 1 && (product.options?.[0].values?.length ?? 0) <= 1))
  )
}
